import { useEffect, useState } from "react"

export function useScreenSize() {
    const [size, setSize] = useState({ innerWidth: window.innerWidth, innerHeight: window.innerHeight })
    useEffect(() => {
        window.addEventListener("resize", onResize)
        return () => window.removeEventListener("resize", onResize)
    }, [])
    return size

    function onResize() {
        setSize({ innerWidth: window.innerWidth, innerHeight: window.innerHeight })
    }
}
